import Home, { getServerSideProps } from './home'

export { getServerSideProps }

export default Home
